import API from "@/config/api.js";
import PartnerService from "../services/partner.service"
import FixedCostService from "./fixedcost.service"


class ProductCostService {
  getListSupplier(page, size, type) {
    return PartnerService.getListData(page, size, type)
  }

  getProductCostDetailForModalByReceivingID(id) {
    return API.get(`cost/product_cost_detail/receiving/?receiving_voucher_id=${id}`)
    .then(
      (response) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error);
      }
    )
  }

  createReceivingProductCostModal(request) {
    return API.post('cost/product_cost_detail/receiving/add', request)
      .then(
        (response) => {
          return response.data;
        },
        (error) => {
          return Promise.reject(error);
        }
      )
  }

  updateReceivingProductCostModal(request) {
    return API.put(`cost/product_cost_detail/receiving/edit/${request.id}`, request)
    .then(
      (response) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error);
      }
    )
  }

  getListPartner(page, size, type) {
    return PartnerService.getPartnerByType(page, size, type)
  }

  getProductCostDetailForModalByDeliveryID(id) {
    return API.get(`cost/product_cost_detail/delivery/?delivery_voucher_id=${id}`)
    .then(
      (response) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error);
      }
    )
  }

  createDeliveryProductCostModal(request) {
    return API.post('cost/product_cost_detail/delivery/add', request)
      .then(
        (response) => {
          return response.data;
        },
        (error) => {
          return Promise.reject(error);
        }
      )
  }

  updateDeliveryProductCostModal(request) {
    return API.put(`cost/product_cost_detail/delivery/edit/${request.id}`, request)
    .then(
      (response) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error);
      }
    )
  }

  searchProductCost(conditions) {
    return API.get(`cost/search/product_cost/?start_date=${conditions.start_date}&end_date=${conditions.end_date}&contract_code=${conditions.contract_code}&receiving_delivery_code=${conditions.receiving_delivery_code}&category_cost=${conditions.category_cost}&partner_id=${conditions.partner_id}&supplier_inv_code=${conditions.supplier_invoice_code}&status=${conditions.status}&page=${conditions.page}`)
    .then(
      (response) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error);
      }
    )
  }

  deleteProductCost(productCostID) {
    return FixedCostService.deleteFixedCost(productCostID)
  }
}

export default new ProductCostService();